import { MessageRecipients } from "../../../../../../components/Messages";

const Recipients = () => {
  return <MessageRecipients />;
};

export default Recipients;
